const local = {

    ru:{
       title: 'CONDTROL РАСШИРЕННАЯ ГАРАНТИЯ',
 description: 'регистрация продуктов CONDTROL',
    keywords: 'регистрация, продление гарантии',
    gotosite: 'Перейти на сайт CONDTROL.RU',
     redline: 'ПРЕДОСТАВЛЕНИЕ ОБЕЩАННОГО СЕРВИСНОГО ОБСЛУЖИВАНИЯ ЛАЗЕРНОГО ИНСТРУМЕНТА',

    },

    en:{
       title: 'CONDTROL EXTENDED WARRANTY SERVICE',
 description: 'CONDTROL product registration',
    keywords: 'registration, warranty prolongation',
    gotosite: 'go to condtrol.com',
     redline: 'Providing the promised laser tool servicing',
    },

    de:{
       title: 'CONDTROL WARRANTY SERVICE',
 description: 'CONDTROL product registration',
    keywords: 'registration, warranty prolongation',
    gotosite: 'go to condtrol.com',
     redline: 'Bereitstellung des zugesagten Garantieservices für Laserwerkzeuge',
    },

};

export default local;